import { HttpResponse } from "@angular/common/http"
import { Component, OnInit } from "@angular/core"
import { ActivatedRoute, Router } from "@angular/router"
import { filter } from "rxjs/operators"
import { UserService } from "../../customer-area/settings/user/shared/user.service"
import { NotificationService } from "../../notification/shared/notification.service"
import { AuthenticationService } from "../shared/authentication/authentication.service"
import { ResetPasswordConfirmForm } from "./reset-password-confirm-form"
import { ResetPasswordConfirmRequest } from "./reset-password-confirm-request"

@Component({
  selector: "app-reset-password-confirm",
  templateUrl: "./reset-password-confirm.component.html",
  styleUrls: ["./../shared/user.scss", "./reset-password-confirm.component.scss", './../login/login.component.scss']
})
export class ResetPasswordConfirmComponent implements OnInit {
  form: ResetPasswordConfirmForm
  formVisibility: Map<string, boolean>;

  resetToken: string
  login: string

  isSize: boolean = false
  isMaj: boolean = false
  isMin: boolean = false
  isNum: boolean = false
  isSpecial: boolean = false
  isNotLogin: boolean = true

  constructor(
    private activedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private notificationService: NotificationService,
    private userService: UserService,
    private router: Router
  ) { }

  private prepareRequest(): ResetPasswordConfirmRequest {
    return new ResetPasswordConfirmRequest(this.resetToken, this.form.get("password").value, this.form.get("confirmPassword").value)
  }

  private succeedResetRequest(response: HttpResponse<string>) {
    this.router.navigate(['/login']).then(() => {
      this.notificationService.notif(response.body, "notif")
    })
  }

  private failedResetRequest(error: any) { }

  public submit() {
    if (this.form.valid) {
      if (this.isValidPassword()) {
        this.authenticationService
          .confirmPasswordReset(this.prepareRequest())
          .subscribe(
            response => this.succeedResetRequest(response),
            error => this.failedResetRequest(error)
          )
      } else {
        this.notificationService.notif("Le nouveau mot de passe ne respecte pas les critères", "error")
      }
    }
  }

  ngOnInit() {
    this.formVisibility = new Map<string, boolean>();
    this.formVisibility.set("firstPassword", false);
    this.formVisibility.set("secondPassword", false);

    this.activedRoute.queryParams
      .pipe(filter(params => params.token))
      .subscribe(params => {
        this.resetToken = params.token
        this.userService.getUserFromToken(this.resetToken).subscribe(user => {
          this.login = user['username']
        })
      })
    this.form = new ResetPasswordConfirmForm()
  }

  public isValidPassword(event: any = null) {
    if (event) {
      let password = event.target.value
      this.isSize = (password.length >= 8)
      this.isMaj = /[A-Z]/.test(password)
      this.isMin = /[a-z]/.test(password)
      this.isNum = /[0-9]/.test(password)
      this.isSpecial = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/.test(password)
      this.isNotLogin = (password !== this.login)
    }
    return this.isSize && this.isMaj && this.isMin && this.isNum && this.isSpecial
  }

  getFormType(formId: string) {
    return this.isVisible(formId) ? "text" : "password";
  }

  isVisible(formId: string) {
    return this.formVisibility.has(formId) && this.formVisibility.get(formId);
  }

  toggleVisibility(formId: string) {
    this.formVisibility.set(formId, !this.isVisible(formId));
  }
}
